<template>
  <div>
    <div v-if="availableAttributes.length" class="mb-3">
      <p class="h5">{{ t.filters }}</p>
      <div class="d-flex flex-column">
        <div
          :key="Object.keys(attribute)[0]"
          v-for="attribute in availableAttributes"
          class="form-check"
        >
          <input
            :checked="selectedAttributes.includes(Object.keys(attribute)[0])"
            :id="Object.keys(attribute)[0]"
            @change="setAttribute(Object.keys(attribute)[0])"
            type="checkbox"
            class="form-check-input"
          />
          <label
            :for="Object.keys(attribute)[0]"
            class="form-check-label cursor-pointer text-sm mb-2"
          >
            {{ Object.values(attribute)[0] }}
          </label>
        </div>
      </div>
    </div>
    <div v-if="visibleItems">
      <p class="h5">{{ t.category }}</p>
      <div class="d-flex flex-column">
        <button
          @click="selectCategory(index)"
          v-close-modal="'categoryChooser'"
          v-for="(category, index) in visibleItems"
          :key="`category-filter-${category.title}`"
          class="text-sm font-weight-normal text-left sidebar-button py-1 mx-n1 px-1"
        >
          {{ category.title }}
        </button>
      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters, mapActions } from "vuex";

export default {
  name: "LunchMenuFilters",
  props: {
    t: {
      type: Object,
      required: true,
    },
  },
  computed: {
    ...mapGetters({
      visibleItems: "lunchMenu/getVisibleItems",
      availableAttributes: "lunchMenu/getAvailableAttributes",
      selectedAttributes: "lunchMenu/getSelectedAttributes",
    }),
  },
  methods: {
    ...mapActions({
      setAttribute: "lunchMenu/setSelectedAttributes",
    }),
    selectCategory(idx) {
      this.$emit("selectCategory", idx);
    },
  },
};
</script>

<style lang="scss" scoped>
@import "~styles/global";

.sidebar-button {
  background: transparent;
  border: none;
  transition: background $transition-duration;
  border-radius: $border-radius;

  &:hover,
  &:focus {
    outline: none;
    background: $gray-100;
  }
}
</style>
